import TeamDetailBadge from '@/screens/TeamDetailBadge';

export default function PrivateTabsOrganizationEventTeamTeamIdBadgeRoute() {
  return <TeamDetailBadge badgePathname="/organization/badge/[badgeId]" />;
}
